import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licence: '=',
        departments: '=',
        roles: '=',
        levels: '='
    },
    template: `
    <div class="well color02">
        <div class="heading01">
            <h2>{{ 'licence.Targets' | translate }}</h2>
            <a class="btn add" ng-click="vm.manage()">{{ 'licence.Add target' | translate }}</a>
        </div>
        <div class="tablewrapper" ng-click="vm.closeAllMenus()">
            <list-empty list="vm.licence.licenceDrlsWithValue" show-add-message="true"></list-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.licence.licenceDrlsWithValue.length">
                <thead>
                <tr>
                    <th><a>{{ 'licence.Department' | translate }}</a></th>
                    <th><a>{{ 'licence.Role' | translate }}</a></th>
                    <th><a>{{ 'licence.Level' | translate }}</a></th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="item in vm.licence.licenceDrlsWithValue">
                    <td>
                        <span ng-if="item.departmentName">{{ item.departmentName }}</span>
                        <span ng-if="!item.departmentName">{{ 'drl.All departments' | translate }}</span>
                    </td>
                    <td>
                        <span ng-if="item.roleName">{{ item.roleName }}</span>
                        <span ng-if="!item.roleName">{{ 'drl.All roles' | translate }}</span>
                    </td>
                    <td>
                        <span ng-if="item.levelName">{{ item.levelName }}</span>
                        <span ng-if="!item.levelName">{{ 'drl.All levels' | translate }}</span>
                    </td>
                    <td class="actions">
                        <div class="action-menu" ng-click="$event.stopPropagation()">
                            <button
                                class="btn"
                                aria-haspopup="true"
                                aria-expanded="{{ !!vm.actions[item.id] }}"
                                ng-click="vm.openActionMenu($event, item.id)"
                                ><span>&nbsp;</span>
                            </button>
                            <ul role="menu" ng-if="vm.actions[item.id]" ng-click="$event.stopPropagation()">
                                <li>
                                   <a ng-click="vm.manage(item)">{{ 'licence.Edit' | translate }}</a>
                                </li>
                                <li>
                                   <a ng-click="vm.delete(item)">{{ 'general.Delete' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, DATATABLES, ModalService, LicenceResource, LicenceDrlResource, FormFactory, toastr,
                 $document, $timeout) {
        this.$translate = $translate;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.LicenceResource = LicenceResource;
        this.LicenceDrlResource = LicenceDrlResource;
        this.FormFactory = FormFactory;
        this.expand = 'licencePeriods,licenceDrlsWithValue';
        this.toastr = toastr;
        this.actions = [];
        this.$timeout = $timeout;

        // Add document click handler to close menus when clicking outside
        this.$document = $document;
        this.$document.on('click', () => {
            // Only close menus if there are any open
            if (this.actions.length > 0) {
                // Use $timeout to ensure immediate UI update
                this.$timeout(() => {
                    this.closeAllMenus();
                }, 0);
            }
        });
    }

    manage (drlWithValue) {
        this.closeAllMenus();
        const { departments, roles, levels, licence } = this;
        const model = new this.LicenceDrlResource({
            id: licence.id,
            licenceDrls: licence.licenceDrlsWithValue
        });
        const form = this.FormFactory.create(model, m => m.$set({ id: m.id, expand: this.expand }));
        return this.ModalService.open({
            template: `
                <modals-drls-add ng-if="!vm.drl"
                    uib-modal-instance="vm.uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    field-prefix="'licence'"
                    form="vm.form"
                 />
                <modals-drls-edit ng-if="vm.drl"
                    uib-modal-instance="vm.uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    drl="vm.drl"
                    field-prefix="'licence'"
                    form="vm.form"
                 />
            `,
            controller ($uibModalInstance) {
                this.uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.drl = drlWithValue;
                this.form = form;
            }
        })
            .then(updatedLicence => {
                this.licence = new this.LicenceResource(updatedLicence);
            });
    }

    delete (item) {
        this.closeAllMenus();
        const confirmMessage = this.$translate.instant('licence.Are you sure you wish to delete this target?');

        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.LicenceDrlResource.delete({ id: item.id }).$promise.then(() => {
                this.fetchList();
                this.toastr.success(this.$translate.instant('licence.Target deleted'));
            });
        });
    }

    fetchList () {
        this.LicenceResource.get({ id: this.licence.id, expand: this.expand }).$promise.then(updated => {
            this.licence.licenceDrlsWithValue = updated.licenceDrlsWithValue;
        });
    }

    openActionMenu ($event, rowId) {
        $event.stopPropagation();
        $event.preventDefault();

        // First close all menus, then toggle the clicked one
        this.$timeout(() => {
            // If this menu is already open, just close it
            if (this.actions[rowId]) {
                this.actions = [];
            }
            else {
                // Close all menus and open only this one
                this.actions = [];
                this.actions[rowId] = true;
            }
        }, 0);
    }

    closeAllMenus () {
        this.$timeout(() => {
            this.actions = [];
        }, 0);
    }

    $onDestroy () {
        // Clean up document click handler when component is destroyed
        if (this.$document) {
            this.$document.off('click');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/targets/index.js